import { render, staticRenderFns } from "./customer-multiselect.vue?vue&type=template&id=634b7633"
import script from "./customer-multiselect.vue?vue&type=script&lang=js"
export * from "./customer-multiselect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports